import { render, staticRenderFns } from "./Galerias.vue?vue&type=template&id=64e044de&"
import script from "./Galerias.vue?vue&type=script&lang=js&"
export * from "./Galerias.vue?vue&type=script&lang=js&"
import style0 from "./Galerias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports